import { Button, Flex, Spinner } from '@chakra-ui/react';
import { toaster } from '@ui/components/Toaster';
import { DEX_NAME } from '@ui/config/layer';
import { useUnwrapTokens } from '@ui/hooks/bondingCurve/useUnwrapTokens';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';
import { useGraduatedTokens } from '@ui/hooks/useGraduatedTokens';
import type { FC } from 'react';

import { useGraduateModal } from '../useGraduateModal';

export const GraduateModalFooter: FC = () => {
  const { data: graduatedTokens } = useGraduatedTokens();
  const tokenAddress = useGraduateModal((s) => s.address);
  const closeModal = useGraduateModal((s) => s.closeModal);
  const openModal = useGraduateModal((s) => s.openModal);
  const { mutateAsync, isLoading } = useUnwrapTokens();
  const chainLayer = useGlobalChainLayer();

  const handleGraduate = async () => {
    try {
      const result = await mutateAsync({ tokenAddress });
      toaster.create({
        type: 'success',
        title: '(＾▽＾) Agent graduated!',
        description: `Now you can trade it on ${DEX_NAME[chainLayer]}!`,
        meta: {
          txHash: result?.hash,
        },
      });
      const nextToken = graduatedTokens?.find(
        (nextToken) => nextToken.bonding_token_address !== tokenAddress,
      );
      if (nextToken) {
        openModal(nextToken.bonding_token_address);
      } else {
        closeModal();
      }
    } catch (error) {
      toaster.create({
        type: 'error',
        title: '(〒︿〒) Something went wrong!',
        description: "Looks like someone had a tiny hiccup, let's try again!",
      });
    }
  };

  return (
    <Flex flexDir="column" align="stretch" gap={2}>
      <Button
        w="full"
        variant="primary"
        onClick={handleGraduate}
        disabled={isLoading}
      >
        {isLoading ? <Spinner /> : 'Unwrap'}
      </Button>
      <Button w="full" variant="tertiary" onClick={closeModal}>
        Later
      </Button>
    </Flex>
  );
};
